(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pdp-offerss"] && !Shopify.designMode) return;
  try {
    (() => {
  const formatINR = (amountInCents) => {
    const amount = amountInCents / 100;
    return amount.toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const updateBannerPrice = (bannerEl, variantPrice, discountPercentage) => {
    if (typeof variantPrice !== "number" || isNaN(variantPrice)) return;

    const discount = Math.max(0, parseFloat(discountPercentage) || 0);

    // Final = price - price*(discount/100)
    const finalPrice = Math.max(
      0,
      Math.round(variantPrice * (100 - discount) / 100)
    );

    bannerEl.textContent = "₹" + formatINR(finalPrice);
  };

  const init = () => {
    const banners = document.querySelectorAll("[data-ai-offer-banner]");
    if (!banners.length) return;

    // ✅ Dawn variant change event
    document.addEventListener("variant:change", (event) => {
      const variant = event.detail?.variant;
      if (!variant) return;

      banners.forEach((bannerEl) => {
        const discountPercentage = bannerEl.dataset.discountPercentage || "0";
        updateBannerPrice(bannerEl, variant.price, discountPercentage);
      });
    });

    // ✅ Fallback for themes that don't fire variant:change properly
    document.addEventListener("change", (event) => {
      const form = event.target.closest("form");
      if (!form) return;

      const variantInput = form.querySelector('input[name="id"], select[name="id"]');
      if (!variantInput) return;

      const variantId = variantInput.value;
      if (!variantId) return;

      const productJsonEl = document.querySelector('script[type="application/json"][data-product-json]');
      if (!productJsonEl) return;

      let productData;
      try {
        productData = JSON.parse(productJsonEl.textContent);
      } catch (e) {
        return;
      }

      const variant = productData?.variants?.find(v => String(v.id) === String(variantId));
      if (!variant) return;

      banners.forEach((bannerEl) => {
        const discountPercentage = bannerEl.dataset.discountPercentage || "0";
        updateBannerPrice(bannerEl, variant.price, discountPercentage);
      });
    });
  };

  document.addEventListener("DOMContentLoaded", init);
  document.addEventListener("shopify:section:load", init);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card-media-slider"] && !Shopify.designMode) return;
  try {
    (function () {
    const sliders = document.querySelectorAll('[data-media-slider]');

    sliders.forEach((slider) => {
      const track = slider.querySelector('[data-media-slider-track]');
      const slides = Array.from(slider.querySelectorAll('[data-media-slider-slide]'));
      const dots = Array.from(slider.querySelectorAll('[data-media-slider-dot]'));

      if (!track || slides.length <= 1) return;

      let currentIndex = 0;
      let startX = 0;
      let currentX = 0;
      let isDragging = false;
      let animationFrame = null;

      const viewportWidth = () => slider.clientWidth || 1;

      function setIndex(index, opts = { animate: true }) {
        const clamped = Math.max(0, Math.min(slides.length - 1, index));
        currentIndex = clamped;

        if (!opts.animate) {
          track.style.transition = 'none';
        } else {
          track.style.transition = '';
        }

        const offset = -clamped * viewportWidth();
        track.style.transform = `translateX(${offset}px)`;

        slides.forEach((slide, i) => {
          slide.classList.toggle('is-active', i === clamped);
        });

        dots.forEach((dot, i) => {
          const isActive = i === clamped;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
      }

      function onDotClick(event) {
        const index = dots.indexOf(event.currentTarget);
        if (index === -1) return;
        setIndex(index);
      }

      function onResize() {
        setIndex(currentIndex, { animate: false });
      }

      function onPointerDown(event) {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        isDragging = true;
        startX = event.clientX;
        currentX = startX;
        track.style.transition = 'none';
        slider.setPointerCapture(event.pointerId);
      }

      function onPointerMove(event) {
        if (!isDragging) return;
        currentX = event.clientX;
        const delta = currentX - startX;

        if (animationFrame) cancelAnimationFrame(animationFrame);
        animationFrame = requestAnimationFrame(() => {
          const baseOffset = -currentIndex * viewportWidth();
          track.style.transform = `translateX(${baseOffset + delta}px)`;
        });
      }

      function onPointerUp(event) {
        if (!isDragging) return;
        isDragging = false;
        slider.releasePointerCapture(event.pointerId);

        const delta = currentX - startX;
        const threshold = viewportWidth() * 0.15;

        if (delta > threshold) {
          setIndex(currentIndex - 1);
        } else if (delta < -threshold) {
          setIndex(currentIndex + 1);
        } else {
          setIndex(currentIndex);
        }
      }

      function onKeyDown(event) {
        if (event.key === 'ArrowRight') {
          setIndex(currentIndex + 1);
        } else if (event.key === 'ArrowLeft') {
          setIndex(currentIndex - 1);
        }
      }

      dots.forEach((dot) => {
        dot.addEventListener('click', onDotClick);
      });

      const viewport = slider.querySelector('.media-slider__viewport');
      if (viewport) {
        viewport.addEventListener('pointerdown', onPointerDown);
        viewport.addEventListener('pointermove', onPointerMove);
        viewport.addEventListener('pointerup', onPointerUp);
        viewport.addEventListener('pointercancel', onPointerUp);
        viewport.tabIndex = 0;
        viewport.addEventListener('keydown', onKeyDown);
      }

      window.addEventListener('resize', onResize);

      setIndex(0, { animate: false });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
